import '../../../../assets/fiat-font.css';
import '../../../../assets/fiat-pro-font.css';
import { fiatTheme } from '../../styles/fiat/fiat-theme';
import '../../assets/third-party-css/index.css';
import { BrandDescriptor, ModuleDescriptor } from './brand-loader';
import { fiatProTheme } from '../../styles/fiat/fiat-pro-theme';

const fiatModules: ReadonlyArray<ModuleDescriptor> = Object.freeze([
  {
    externalName: 'WelcomeTextWidget',
    entryPoint: async () => {
      await import('../../../welcome-text/common/common-welcome-text-widget');
      return import('../../../welcome-text/fiat/fiat-welcome-text-widget').then((wtw) => wtw.WelcomeTextWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'CarSearchWidget',
    entryPoint: async () => {
      await import('../../components/input/slider/general/slider-common');
      await import('../../../car-search-widget/common/common-car-search-widget');
      return import('../../../car-search-widget/fiat/fiat-car-search-widget').then((csw) => csw.CarSearchWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'Showroom',
    entryPoint: async () => {
      await import('dompurify');
      await import('../../../showroom/common/common-showroom');
      return import('../../../showroom/fiat/fiat-showroom').then((showroom) => showroom.FiatShowroomComponent);
    },
    labelPrefix: 'showroom',
  },
  {
    externalName: 'ModShowroom',
    entryPoint: async () => {
      await import('dompurify');
      await import('../../../showroom/common/common-showroom');
      return import('../../../showroom/fiat/v2/fiat-showroom_v2').then((showroom) => showroom.FiatShowroomV2Component);
    },
    labelPrefix: 'showroom',
  },
  {
    externalName: 'OfferWidget',
    entryPoint: async () => {
      await import('../../../offer-widget/common/common-offer-widget');
      return import('../../../offer-widget/fiat/fiat-offer-widget').then((ow) => ow.FiatOfferWidgetComponent);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'CatwalkWidget',
    entryPoint: async () => {
      await import('../../../catwalk-widget/common/common-catwalk-widget');
      return import('../../../catwalk-widget/fiat/fiat-catwalk-widget').then((cat) => cat.FiatCatwalkWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'VACS',
    entryPoint: async () => {
      await import('../../../location/common/common-location');
      await import('../../components/input/slider/general/slider-common');
      await import('../../../vacs/common/common-vacs');
      return import('../../../vacs/fiat/fiat-vacs').then((vacs) => vacs.VACS);
    },
    labelPrefix: 'vacs',
  },
  {
    externalName: 'StandardProWidget',
    entryPoint: async () => {
      await import('../../../location/common/common-location');
      await import('../../../standard-pro-widget/fiat/fiat-standard-pro-image-and-text-widget');
      await import('../../../standard-pro-widget/fiat/fiat-standard-pro-downloads-widget');
      await import('../../../standard-pro-widget/fiat/fiat-standard-pro-banner-widget');
      return import('../../../standard-pro-widget/fiat/fiat-standard-pro-widget').then(
        (spw) => spw.FiatStandardProWidget
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetText',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/fiat/fiat-standard-pro-text-widget').then(
        (spw) => spw.FiatStandardProWidgetText
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'FooterWidget',
    entryPoint: async () => {
      return import('../../../footer/fiat/fiat-footer-widget').then((footer) => footer.FooterWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetBanner',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/fiat/fiat-standard-pro-banner-widget').then(
        (spw) => spw.FiatStandardProWidgetBanner
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetDownloads',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/fiat/fiat-standard-pro-downloads-widget').then(
        (spw) => spw.FiatStandardProWidgetDownloads
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetGallery',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/fiat/fiat-standard-pro-gallery-widget').then(
        (spw) => spw.FiatStandardProWidgetGallery
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetImageAndText',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/fiat/fiat-standard-pro-image-and-text-widget').then(
        (spw) => spw.FiatStandardProWidgetImageAndTextWidget
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetMultipleImageAndText',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/fiat/fiat-standard-pro-multi-image-and-text-widget').then(
        (spw) => spw.FiatStandardProWidgetMultiImageAndText
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetTable',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/fiat/fiat-standard-pro-table-widget').then(
        (spw) => spw.FiatStandardProWidgetTable
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetVideo',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/fiat/fiat-standard-pro-video-widget').then(
        (spw) => spw.FiatStandardProWidgetVideo
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetTabs',
    entryPoint: async () => {
      await import('../../../standard-pro-widget/fiat/fiat-standard-pro-image-and-text-widget');
      await import('../../../standard-pro-widget/fiat/fiat-standard-pro-downloads-widget');
      await import('../../../standard-pro-widget/fiat/fiat-standard-pro-banner-widget');
      await import('../../../standard-pro-widget/fiat/fiat-standard-pro-video-widget');
      return import('../../../standard-pro-widget/fiat/fiat-standard-pro-tabs-widget').then(
        (spw) => spw.FiatStandardProWidgetTabs
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'Location',
    entryPoint: async () => {
      await import('../../../location/common/common-location');
      return import('../../../location/fiat/fiat-location').then((loc) => loc.FiatLocationPage);
    },
    labelPrefix: 'location',
  },
  {
    externalName: 'Webform',
    entryPoint: async () => {
      await import('dompurify');
      await import('classnames');
      await import('resize-observer-polyfill');
      await import('../../../location/common/common-location');
      await import('../../../common-form-widget/common-form-index-widget');
      return import('../../../common-form-widget/fiat/fiat-common-form-widget').then(
        (form) => form.FiatCommonFormWidget
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'BannerWidget',
    entryPoint: async () => {
      return import('../../../banner/fiat/fiat-banner-widget').then((banner) => banner.FiatBannerWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'TestPageWidget',
    entryPoint: async () => {
      return import('../../../test-page/fiat/fiat-test-page-widget').then((tpw) => tpw.TestPageWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'EQuoteWidget',
    entryPoint: async () => {
      await import('../../../location/common/common-location');
      return import('../../../e-quote/fiat/fiat-e-quote-widget').then((equote) => equote.FiatEQuoteWidget);
    },
    labelPrefix: 'widget',
  },
]);

export type ParameterizedBrandDescriptor = (param?: any) => BrandDescriptor;

const loadFiat: ParameterizedBrandDescriptor = (customData: any) => {
  const theme = !(customData?.isFiatPro === true || customData?.isFiatPro === 'true') ? fiatTheme : fiatProTheme;

  return [fiatModules, theme];
};

export default loadFiat;
